var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialIconFacebookRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "background",
    fill: "#ffffff",
    d: "M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    fill: "#3d3d3d",
    d: "M19.73,16H17.29v8.7H13.67V16H12V12.93h1.72v-2a3.39,3.39,0,0,1,3.65-3.65H20v3H18.06a0.74,0.74,0,0,0-.77.84v1.81H20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "border",
    fill: "#3d3d3d",
    d: "M16,31.5C7.45,31.5,0.5,24.55,0.5,16S7.45,0.5,16,0.5S31.5,7.45,31.5,16S24.55,31.5,16,31.5z M16,1.5     C8,1.5,1.5,8,1.5,16S8,30.5,16,30.5S30.5,24,30.5,16S24,1.5,16,1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconFacebookRound);
export default __webpack_public_path__ + "static/media/social-icon-facebook-round.582fbfb1aa3fa46485e945f3ecef26f0.svg";
export { ForwardRef as ReactComponent };